import { Button } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

export default function BackButton ({ children = '← Back', fallback, showOnlyWhenCanGoBack = false, iconOnly = false, ...buttonProps }) {
  const navigate = useNavigate()
  const canGoBack = (window.history.state?.idx || 0) > 0

  if (showOnlyWhenCanGoBack && !canGoBack) return null

  return (
    <Button
      {...buttonProps}
      icon={iconOnly ? <ArrowLeftOutlined /> : buttonProps.icon}
      onClick={() => {
        if (canGoBack) navigate(-1)
        else if (fallback) navigate(fallback)
      }}
    >
      {iconOnly ? null : children}
    </Button>
  )
}
